const eventPhoneNumber = (param, page) => {
  if (typeof window !== 'undefined') {
    (window as any)?.dataLayer?.push({
      event: `generalEvent`,
      eventName: `branch_phone_number_button`,
      eventCategory: `localized landing page`,
      eventAction: `click on phone number`,
      eventLabel: `branch page - ${page}`,
      cabangBooking: `${param?.city?.province?.name?.toLowerCase()} - ${param?.city?.name?.toLowerCase()} - ${param?.displayName?.toLowerCase()}`,
    });
  }
};
export default eventPhoneNumber;
